export default __webpack_public_path__ + "static/media/banner1.dbfe0c9e.png";